import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiDialog from "components/Custom/UiDialog";

import { COMMON_JS } from "common/scripts";
import { DEFAULTS, FORMATS, NOTIFY } from "common/config";
import { DateFunctions } from "common/datefunctions";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";

import { MASTER_APIs } from "apihandlers/master";
import { USER_APIs } from "apihandlers/user";
import Area from "components/Masters/Area";
import { GEO_APIs } from "apihandlers/geography";
import { PRODUCT_APIs } from "apihandlers/product";
import { REPORTS_APIs } from "apihandlers/reports";

const OnePager = (props: any) => {
  const { setDashMenu } = props;
  const [rows, setRows] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "performance",
      name: LABELS.PERFORMANCE,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "ftd",
      name: LABELS.FTD,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "mtd",
      name: LABELS.MTD,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "mtdTarget",
      name: LABELS.MTD_TARGET,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "previousMonth",
      name: LABELS.PREVIOUS_MONTH,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "ytd",
      name: LABELS.YTD,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
  ];

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  // const getRows = () => {
  //   const args = {
  //     pageNo: 1,
  //     pageLength: DEFAULTS.PAGE_LENGTH,
  //   };
  //   MASTER_APIs.getVehicleChecks(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list = response.records;
  //       for (let i = 0; i < list.length; i++) {
  //         list[i]["slNo"] = i + 1;
  //         if (list[i]["activeStatus"]) {
  //           list[i]["activeStatus"] = "Yes";
  //         } else {
  //           list[i]["activeStatus"] = "No";
  //         }
  //       }
  //       setRows(list);
  //       setLoading(false);
  //     }
  //   });
  // };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const getRows = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    console.log("Args", args);
    REPORTS_APIs.getOnePager(args).then((res: any) => {
      const response: any = res.response;

      const { status } = res;

      if (status === 200) {
        let list = response.records;
        console.log("response", list);
        let count = 0;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1 - count;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
          if (list[i].subData) {
            count++;
            list[i]["slNo"] = "";
          }
        }
        setRows(list);
        // setLoading(true);
      }
    });
  };

  console.log("Page: Country:", rows);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.REPORTS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.ONE_PAGER}</li>
        </ul>
        <h4>{TITLES.ONE_PAGER}</h4>
        <p>{SUB_TITLES.ONE_PAGER}</p>
      </div>

      <div className="grid excelGridWrapper">
        {loading ? (
          rows && (
            <ExcelGrid
              id={"onePager"}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.ONE_PAGER}
              onReload={reloadGrid}
            />
            // ) : (
            //   <div className="flexRowCenter">
            //     <Loader />s
            //   </div>
          )
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default withSnackbar(OnePager);
